document.querySelectorAll('.shopify-section--ugc-content .ugc-slide__item').forEach(container => {
  const video = container.querySelector('.video-background video');
  const playButton = container.querySelector('.play-btn');

  video.pause();

  playButton.addEventListener('click', () => {
      video.play();
      video.muted = false;
      video.setAttribute('controls', 'controls');
      playButton.classList.add('hidden');
  });

  video.addEventListener('pause', () => {
      playButton.classList.remove('hidden');
      video.removeAttribute('controls');
  });
}); 